import {
	ArrowDownward as ArrowDownwardIcon,
	CellTower as CellTowerIcon,
	ContentCopy as ContentCopyIcon,
	GpsFixed as GpsFixedIcon,
	LocationOn as LocationOnIcon,
} from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';

interface GeoLocationIconProps extends SvgIconProps {
	locationType:
		| 'gpsFix'
		| 'gpsCopied'
		| 'cellTowerRequested'
		| 'cellTowerCopied'
		| 'dockingLocation'
		| 'none';
}

/**
 * An geolocation icon based on the type of location
 */
const GeoLocationIcon = ({
	locationType,
	fontSize = 'small',
	...iconProps
}: GeoLocationIconProps) => {
	switch (locationType) {
		case 'gpsFix':
			return <GpsFixedIcon {...iconProps} fontSize={fontSize} />;
		case 'gpsCopied':
			return <ArrowDownwardIcon {...iconProps} fontSize={fontSize} />;
		case 'cellTowerRequested':
			return <CellTowerIcon {...iconProps} fontSize={fontSize} />;
		case 'cellTowerCopied':
			return <ContentCopyIcon {...iconProps} fontSize={fontSize} />;
		case 'dockingLocation':
			return <LocationOnIcon {...iconProps} fontSize={fontSize} />;
		default:
			return null;
	}
};

export default GeoLocationIcon;
